var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#FFF4E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#FFF4E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H18V10.5C18 9.70435 17.6839 8.94129 17.1213 8.37868C16.5587 7.81607 15.7956 7.5 15 7.5C14.2044 7.5 13.4413 7.81607 12.8787 8.37868C12.3161 8.94129 12 9.70435 12 10.5V12H10C9.73478 12 9.48043 12.1054 9.29289 12.2929C9.10536 12.4804 9 12.7348 9 13V20C9 20.2652 9.10536 20.5196 9.29289 20.7071C9.48043 20.8946 9.73478 21 10 21H20C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20V13C21 12.7348 20.8946 12.4804 20.7071 12.2929C20.5196 12.1054 20.2652 12 20 12ZM13 10.5C13 9.96957 13.2107 9.46086 13.5858 9.08579C13.9609 8.71071 14.4696 8.5 15 8.5C15.5304 8.5 16.0391 8.71071 16.4142 9.08579C16.7893 9.46086 17 9.96957 17 10.5V12H13V10.5ZM20 20H10V13H20V20ZM15.75 16.5C15.75 16.6483 15.706 16.7933 15.6236 16.9167C15.5412 17.04 15.4241 17.1361 15.287 17.1929C15.15 17.2497 14.9992 17.2645 14.8537 17.2356C14.7082 17.2066 14.5746 17.1352 14.4697 17.0303C14.3648 16.9254 14.2933 16.7918 14.2644 16.6463C14.2355 16.5008 14.2503 16.35 14.3071 16.213C14.3639 16.0759 14.46 15.9588 14.5833 15.8764C14.7067 15.794 14.8517 15.75 15 15.75C15.1989 15.75 15.3897 15.829 15.5303 15.9697C15.671 16.1103 15.75 16.3011 15.75 16.5Z",
    fill: "#ED6C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/Insurance.825492f8961887815ff661264f947963.svg";
export { ForwardRef as ReactComponent };